import Splide from '@splidejs/splide';
import enquire from 'enquire.js';
import { Responsive, Translations } from '../utils';
import './portfolio-immobiliare-filter-buttons.scss';

const COMPONENT_NAME = 'portfolio-immobiliare-filter-buttons';
const EVENTS = {
  FILTER_CHANGE: `filterChange.${COMPONENT_NAME}`,
};

const BEM = {
  BLOCK: COMPONENT_NAME,
  SLIDER: `${COMPONENT_NAME}__slider`,
  BTN: 'btn',
  BTN_PRIMARY: 'btn-primary',
  BTN_SECONDARY: 'btn-secondary',
  BTN_NUMBER: 'btn-number',
};

const FILTER_ALL = 'tutti';
const LISTING_CARD_SELECTOR = 'article[data-category]';

/**
 * version    1.1
 * class      PortfolioImmobiliareFilterButtons
 */
export class PortfolioImmobiliareFilterButtons {
  constructor() {
    this._splide = null;
    this._findUIElements();
    this._bindEvents();
    this._initResponsive();
    this._updateCounters();
  }

  _findUIElements() {
    this._els = {
      section: $(`.${BEM.BLOCK}`),
      slider: document.querySelector(`.${BEM.SLIDER}`),
      list: document.querySelector(`.${BEM.SLIDER} .splide__list`),
      buttons: $(`.${BEM.BLOCK} .${BEM.BTN}[data-filter]`),
      listingCards: $(LISTING_CARD_SELECTOR),
    };
  }

  _updateCounters() {
    if (!this._els.listingCards.length) return;

    const countsByCategory = {};
    this._els.listingCards.each((i, card) => {
      const category = $(card).data('category');
      countsByCategory[category] = (countsByCategory[category] || 0) + 1;
    });

    const totalCount = this._els.listingCards.length;

    this._els.buttons.each((i, btn) => {
      const $btn = $(btn);
      const filter = $btn.data('filter');
      const count = filter === FILTER_ALL ? totalCount : (countsByCategory[filter] || 0);
      $btn.find(`.${BEM.BTN_NUMBER}`).text(` (${count})`);
    });
  }

  _bindEvents() {
    this._els.buttons.on(`click.${COMPONENT_NAME}`, (e) => {
      this._onButtonClick($(e.currentTarget));
    });
  }

  // Responsive: Splide sotto i 992px (max-width: 991px)
  _initResponsive() {
    if (!this._els.slider) return;

    enquire.register(Responsive.getBreakpointMaxMediaQuery('lg'), {
      match: () => this._initSlider(),
      unmatch: () => this._destroySlider(),
    });
  }

  _initSlider() {
    if (this._splide) return;

    this._splide = new Splide(this._els.slider, {
      type: 'slide',
      arrows: false,
      pagination: true,
      autoWidth: true,
      gap: '12px',
      drag: 'free',
      i18n: Translations.getSplideI18n(),
    });

    this._splide.mount();
  }

  _destroySlider() {
    if (!this._splide) return;
    this._splide.destroy(true);
    this._splide = null;

    if (this._els.slider) {
      // Rimuove la pagination dal DOM (destroy(true) non la rimuove sempre)
      const pagination = this._els.slider.querySelector('.splide__pagination');
      if (pagination) pagination.remove();
      // Resetta inline styles residui (transform translateX, transition, ecc.)
      const track = this._els.slider.querySelector('.splide__track');
      const list = this._els.slider.querySelector('.splide__list');
      if (track) track.removeAttribute('style');
      if (list) list.removeAttribute('style');
    }
  }

  _onButtonClick($btn) {
    if ($btn.hasClass(BEM.BTN_PRIMARY)) return;

    this._els.buttons
      .removeClass(BEM.BTN_PRIMARY)
      .addClass(BEM.BTN_SECONDARY)
      .attr('aria-pressed', 'false');

    $btn
      .removeClass(BEM.BTN_SECONDARY)
      .addClass(BEM.BTN_PRIMARY)
      .attr('aria-pressed', 'true');

    const filterValue = $btn.data('filter');
    this._els.section.trigger(EVENTS.FILTER_CHANGE, { filter: filterValue });
  }
}
